import update from "immutability-helper";
import { useCallback, useEffect, useState } from "react";

export const useDragAndDropList = (list) => {
    const [cards, setCards] = useState(list);
    const onMoveCard = useCallback((dragIndex, hoverIndex) => {
        setCards((prevCards) =>
            update(prevCards, {
                $splice: [
                    [dragIndex, 1],
                    [hoverIndex, 0, prevCards[dragIndex]],
                ],
            })
        );
    }, []);

    useEffect(() => {
        setCards(list);
    }, [list]);

    return { cards, onMoveCard };
};
